import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { BackArrow } from '../svgIcons';

const Wrapper = styled.div`
  width: fit-content;
  margin: auto
`

const BackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  p {
    font-size: 12px;
    margin-top: 1px;
  }
`

const BackButton = ({ backText, analytics={}, onClick }) => {
  return (
    <Wrapper {...analytics} onClick={onClick}>
      <BackContainer>
        <BackArrow width="21" height="12" />
        <h4>Back</h4>
        <p>{backText}</p>
      </BackContainer>
    </Wrapper>
  )
}

BackButton.propTypes = {
  backText: PropTypes.string,
  analytics: PropTypes.object,
  onClick: PropTypes.func
};

export default BackButton;

// Example Usage

{/* <BackButton
analytics={{
  "data-track": "form-back",
  "data-track-form-name": "Submit Claim Photos",
  "data-track-form-step": "step 8 - photos"
}}
onClick={() => dispatch(decrementStep())}
backText={'Documents'}
/> */}
